webpackJsonp([179809959210745],{

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _getComponent = __webpack_require__(12);
	
	var _getComponent2 = _interopRequireDefault(_getComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Home Page
	 * @param {object} props Incoming Props
	 * @returns {XML} A Home Page
	 */
	var TermsPage = function TermsPage(_ref) {
	  var _ref$data = _ref.data,
	      allContentfulNewsArticle = _ref$data.allContentfulNewsArticle,
	      edges = _ref$data.data.edges,
	      dataJson = _ref$data.dataJson,
	      site = _ref$data.site;
	
	  var pageComponents = [];
	  var showCities = site && site.siteMetadata && site.siteMetadata.showCities;
	  if (edges && edges.length > 0 && edges[0].node && edges[0].node.components) {
	    pageComponents = edges[0].node.components;
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Deposit Terms',
	      meta: [{
	        name: 'description',
	        content: 'Terms and conditions for season ticket deposits.'
	      }, {
	        name: 'robots',
	        content: 'noindex,nofollow'
	      }]
	    }),
	    pageComponents && pageComponents.map(function (component, index) {
	      return (0, _getComponent2.default)({
	        component: component,
	        allContentfulNewsArticle: allContentfulNewsArticle,
	        index: index,
	        dataJson: dataJson,
	        showCities: showCities
	      });
	    })
	  );
	};
	exports.default = TermsPage;
	// eslint-disable-next-line
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-deposit-terms-js-698b6664b02d9bcce9fd.js